<div
  [ngSwitch]="customField?.type"
  class="custom-field-cell-editor__wrapper"
  (keydown.enter)="saveCustomField($event)"
>
  <input
    matInput
    *ngSwitchCase="customFieldType.STRING"
    type="text"
    class="w-full"
    [disabled]="(loading$ | async) || false"
    [(ngModel)]="value"
  />
  <input
    matInput
    lumDecimalLimit
    *ngSwitchCase="customFieldType.NUMBER"
    type="number"
    class="w-full"
    [disabled]="(loading$ | async) || false"
    [decimalPlaces]="2"
    [invalidKeys]="['+']"
    [(ngModel)]="value"
  />
  <input
    matInput
    *ngSwitchCase="customFieldType.DATE"
    type="date"
    class="w-full"
    [disabled]="(loading$ | async) || false"
    [(ngModel)]="value"
  />
  <mat-select
    *ngSwitchCase="customFieldType.DROPDOWN"
    class="w-full"
    [disabled]="(loading$ | async) || false"
    [(ngModel)]="value"
  >
    <mat-option [value]="''"> --None-- </mat-option>
    <mat-option *ngFor="let option of customField?.options" [value]="option">
      {{ option }}
    </mat-option>
  </mat-select>

  <mat-progress-spinner
    *ngIf="loading$ | async"
    class="progress-spinner"
    diameter="16"
    mode="indeterminate"
  ></mat-progress-spinner>

  <div class="action-buttons" *ngIf="!(loading$ | async)">
    <button (click)="onCancelEditing()">
      <mat-icon class="text-red-600">close</mat-icon>
    </button>
    <button (click)="saveCustomField()">
      <mat-icon class="text-green-600">check</mat-icon>
    </button>
  </div>
</div>
